<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'users.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <Grid ref="usersGrid" name="usersGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import kendo from '@progress/kendo-ui/js/kendo.all.js' // eslint-disable-line no-unused-vars

export default {
  name: 'UsersGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      url: 'admin/users',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '80px'
      },
      {
        command: {
          text: 'Apagar',
          click: this.deleteUser
        },
        width: '80px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '120px'
      },
      {
        field: 'name',
        title: 'Nome',
        width: '220px'
      },
      {
        field: 'state',
        title: 'Estado',
        width: '120px',
        values: [{
          text: 'Activo',
          value: 1
        }, {
          text: 'Bloqueado',
          value: 0
        }]
      },
      {
        field: 'email',
        title: 'Email',
        width: '220px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    deleteUser: function(e) {
      e.preventDefault()
      var grid = this.$refs.usersGrid.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.showDeleteUserConfirm(dataItem)
    },
    showDeleteUserConfirm(item) {
      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('Quer mesmo apagar este utilizador?', {
        title: 'Apagar utilizador?',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'SIM',
        cancelTitle: 'Cancelar',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if (value) {
            this.axios.delete('admin/users/' + item.id).then(response => {
              var grid = this.$refs.usersGrid.$refs.mygrid.kendoWidget()
              grid.dataSource.read()
            })
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'users.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('roles.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-edit"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// UsersGrid.vue?376a3a8c